import type { FC } from 'react';
import React, { memo } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { layersLayer } from '@confluence/typography-placeholder';
import { fg } from '@confluence/feature-gating';

import type { CloseButtonComponentProps } from './CloseButton';
import { CloseButton } from './CloseButton';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.div({
	position: 'sticky',
	top: token('space.negative.200', '-16px'),
	padding: `${token('space.200', '16px')} 14px 0px`,
	background: token('elevation.surface'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layersLayer,
	margin: `${token('space.negative.200', '-16px')} -14px 0px`,
	display: 'flex',
	justifyContent: 'flex-end',
	height: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RefinedHeader = styled.div({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layersLayer,
	margin: `${token('space.negative.200', '-16px')} -14px 0px`,
	display: 'flex',
	justifyContent: 'flex-end',
	height: 0,
});

export const Heading: FC<CloseButtonComponentProps> = memo(
	({ onClose, closeLabel, closeAutoFocus }) => {
		const HeaderComponent = fg('company_hub_config_panel_refinement') ? RefinedHeader : Header;

		return (
			<HeaderComponent>
				<CloseButton onClose={onClose} closeLabel={closeLabel} closeAutoFocus={closeAutoFocus} />
			</HeaderComponent>
		);
	},
);
